<template>
  <div id="hello">
    ...
  </div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  mounted () {
    console.log('hello')
    console.log(this.$j('#hello'))
  }
}
</script>


// WEBPACK FOOTER //
// Hello.vue?ed675370